<template>
    <v-layout column fill-height>
        <v-app-bar :clipped-left="toolbar.clippedLeft" app color="primary" dark>
            <v-row align="center">
                <v-col>
                    <v-toolbar-title width="400">
                        <day-nav v-if="$route.name == 'calendar-day'"></day-nav>
                        <month-nav v-if="$route.name == 'calendar-month'"></month-nav>
                    </v-toolbar-title>
                </v-col>
                <v-col>
                    <v-tabs icons-and-text background-color="transparent" height="60">
                        <v-tab :to="{name:'calendar-month'}">
                            Month View
                            <v-icon medium>event</v-icon>
                        </v-tab>
                        <v-tab :to="{name:'calendar-day'}">
                            Day View
                            <v-icon medium>event_note</v-icon>
                        </v-tab>
                    </v-tabs>
                </v-col>

                <v-col md3>
                    <garage-select></garage-select>
                </v-col>
            </v-row>
        </v-app-bar>
        <v-container fill-height fluid>
            <router-view></router-view>
        </v-container>
        <complete-service></complete-service>
        <complete-date-based-task></complete-date-based-task>
        <complete-defect></complete-defect>
        <complete-campaign></complete-campaign>
    </v-layout>
</template>
<script>
  import DayNav from '@/components/Calendar/Day/Nav.vue';
  import MonthNav from '@/components/Calendar/MonthNav.vue';
  import CompleteService from '@/components/Services/CompleteService.vue';
  import CompleteDefect from '@/components/DefectNotices/CompleteDefect.vue';
  import CompleteCampaign from '@/components/Campaigns/CompleteCampaign.vue';
  import GarageSelect from '@/components/GarageLocations/GarageSelect.vue';
  import GarageLocationsClient from '@/components/GarageLocations/GarageLocationsClient.vue';
  import CompleteDateBasedTask from '@/components/DateBasedTasks/CompleteDateBasedTask';
  import UnitsClient from '@/components/Units/UnitsClient.vue';

  export default {
    components: {
      CompleteDateBasedTask,
      DayNav,
      MonthNav,
      GarageSelect,
      CompleteService,
      CompleteDefect,
      CompleteCampaign
    },
    mixins: [GarageLocationsClient, UnitsClient],
    data: () => ({
      drawer: {
        open: true,
        clipped: false,
        mini: true
      },
      toolbar: {
        fixed: true,
        clippedLeft: false
      }
    }),
    async mounted() {
      await this.getGarageSelections();
    }
  };
</script>
<style>
    .calendar-controls {
        justify-content: center;
    }
</style>
